module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("eb8gQ"))).then(() => parcelRequire('dBE7n'));